import { HOC_MDXWrapper } from 'nextra/setup-page'
import { pageMap } from '/ui/docs-site/.next/static/chunks/nextra-page-map-.mjs'
/*@jsxRuntime automatic*/
/*@jsxImportSource react*/
/*-- dri: Garrett Guillotte --*/
import {useMDXComponents as _provideComponents} from "nextra/mdx";
const title = "Administer your tools and users";
const frontMatter = {
  "title": "Administer your tools and users",
  "description": "Chronosphere Observability Platform offers tools and guidance for managing users, teams, collections, and your infrastructure-as-code settings."
};
export function useTOC(props) {
  return [{
    value: "Cost control",
    id: "cost-control",
    depth: 2
  }, {
    value: "Data collection",
    id: "data-collection",
    depth: 2
  }, {
    value: "Data usability",
    id: "data-usability",
    depth: 2
  }, {
    value: "Platform usability",
    id: "platform-usability",
    depth: 2
  }];
}
function MDXLayout(props) {
  const {toc = useTOC(props)} = props;
  const _components = {
    a: "a",
    h1: "h1",
    h2: "h2",
    p: "p",
    ..._provideComponents(),
    ...props.components
  };
  return <>{}{"\n"}<_components.h1>{"Administer your tools and users"}</_components.h1>{"\n"}<_components.p>{"Administrative users focus on observability tools so that developers can use those\ntools to monitor and maintain the health of their distributed system. As an\nadministrative user, you might focus on one or more of the following tasks."}</_components.p>{"\n"}<_components.h2 id={toc[0].id}>{toc[0].value}</_components.h2>{"\n"}<_components.p>{"Manage license consumption by\n"}<_components.a href="/observe/dashboards/chronosphere-managed-dashboards#licensing-information">{"reviewing licensing dashboards"}</_components.a>{"\nto identify usage trends and avoid exceeding your organization’s licensing limits.\nUse the Chronosphere Control Plane to\n"}<_components.a href="/control/shaping">{"shape your metric data"}</_components.a>{", downsample data, and reduce the\namount of data you persist. You can also\n"}<_components.a href="/control/sampling">{"create sampling rules"}</_components.a>{" to manage the tracing data\nyou keep and discard."}</_components.p>{"\n"}<_components.h2 id={toc[1].id}>{toc[1].value}</_components.h2>{"\n"}<_components.p><_components.a href="/ingest">{"Ingest telemetry data"}</_components.a>{" into Chronosphere Observability Platform, which can\ninclude metrics, traces, and change events. Your Collector selection depends on the\ndata you plan to ingest. Chronosphere recommends using the Chronosphere Collector,\nbut can also ingest data from the OpenTelemetry Collector."}</_components.p>{"\n"}<_components.h2 id={toc[2].id}>{toc[2].value}</_components.h2>{"\n"}<_components.p><_components.a href="/investigate">{"Explore your data"}</_components.a>{" to understand where you can normalize,\nsanitize, and optimize telemetry data to make it usable for developers and to filter\nout less useful data. "}<_components.a href="/investigate/metrics">{"Analyze usage metrics"}</_components.a>{" and\nimplement aggregation rules to improve the quality and reduce the cardinality of\nstored metrics data."}</_components.p>{"\n"}<_components.h2 id={toc[3].id}>{toc[3].value}</_components.h2>{"\n"}<_components.p>{"Create and manage "}<_components.a href="/administer/collections">{"collections"}</_components.a>{" to group Observability\nPlatform resources associated with a service or feature you want to monitor. You\ncreate "}<_components.a href="/administer/accounts-teams/teams">{"teams"}</_components.a>{" to organize accounts into groups and\ndefine permissions for sensitive management and administrative operations. A team’s\naccounts have shared responsibility for individual services, which Observability\nPlatform represents as collections."}</_components.p></>;
}


export default HOC_MDXWrapper(
  MDXLayout,
  '/administer',
  {"filePath":"pages/administer.mdx",pageMap,frontMatter,title},
  typeof RemoteContent === 'undefined' ? useTOC : RemoteContent.useTOC
)